import type { CompanyType, PartnerCapability } from "@/schema/company"

export function partnerOAuthCapability(state: { provider?: string; integration_type?: string }): PartnerCapability {
  const phoneProvider =
    ["ringcentral", "current_client", "dialpad", "intulse", "goto", "elevate"].includes(state.provider ?? "") ||
    (state.provider === "zoom" && state.integration_type !== "zoom_scheduler")
  return phoneProvider ? "phone_integrations" : "full_product_access"
}

export function canAccessPartnerFeature(
  companyType: CompanyType | undefined,
  capabilities: PartnerCapability[] | undefined,
  capability: PartnerCapability
) {
  if (!companyType) return false
  return (
    companyType !== "integration_partner" ||
    capabilities?.includes("full_product_access") === true ||
    capabilities?.includes(capability) === true
  )
}

export function canAccessPartnerDashboard(fullProductAccess: boolean, defaultKey?: string, editing = false) {
  return fullProductAccess || (!editing && (defaultKey === "overview" || defaultKey === "activity"))
}
